import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Form, Input, Button, Tooltip, Typography, Col, Row } from 'antd';
import styles from './enrichment-landing.module.sass';
import isIP from 'validator/lib/isIP';
import mixpanel from 'mixpanel-browser';
import { ReactComponent as enrichmentIcon } from '../../../../assets/icons/enrichment-icon.svg';
import Icon, { ExclamationCircleOutlined } from '@ant-design/icons';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { STATUS } from '../../../../redux/constants';
import { changeTitle } from '../../../../redux/actions/app';
import Panel from '../../../../shared-components/Panel';
import {
  showNotification,
  simpleErrorNotification,
} from '../../../../shared-components/Notifications';
import { validateEnrichInput } from '../../../../shared-components/Validation/Enrichment';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';

function EnrichmentLanding(props) {
  mixpanel.track('Global Nav - Enrichment', { location: window.location.href });
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const location = useLocation();
  const q = useQuery();
  const [name, setName] = useState(q.get('name'));
  const [type, setType] = useState(q.get('type'));
  const [selectedAdvancedQuery, setSelectedAdvancedQuery] = useState('any');
  const [enrichInputState, setEnrichInputState] = useState('valid');
  const searchInput = useRef(null);
  const { Title, Text } = Typography;

  useEffect(() => {
    const searchParams = new URLSearchParams(props.location.search);
    const IOC_name = searchParams.get('name') || '';
    const type = searchParams.get('type') || '';
    setName(IOC_name);
    setType(type);
    setTimeout(() => {
      searchInput && searchInput.current && searchInput.current.focus();
    }, 100);
  }, [location.key]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.title = 'Enrichment - Silent Push';
    // eslint-disable-next-line
    props?.loadUser();
    props.clearExploreDetails();
    dispatch(changeTitle('Enrichment', null));
    props.loadMySubscriptionPlan();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onInputChange = (e) => {
    if (enrichInputState === 'error') {
      // this.setState({ exploreInputState: 'valid' });
      setEnrichInputState('valid');
    }
    setTimeout(() => {
      searchInput && searchInput.current && searchInput.current.focus();
    }, 100);
    // if (isIP(e?.target?.value) && !e?.target?.value?.includes(':')) {
    //   setSelectedAdvancedQuery('ANYIPV4');
    // } else if (isIP(e?.target?.value) && e?.target?.value?.includes(':')) {
    //   setSelectedAdvancedQuery('ANYIPV6');
    // } else if (selectedAdvancedQuery === 'ANYIPV4') {
    //   setSelectedAdvancedQuery('any');
    // }
  };

  return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
    props.mySubscriptionPlan?.has_access_to_enrich ? (
      <Row gutter={24} className={styles.enrichment_landing}>
        <Col xs={18} md={12} xl={8}>
          <div className={styles.enrichment_landing_panel}>
            <Panel bgcolor={'#1C3138'}>
              <Icon className={styles.icon} component={enrichmentIcon} />
              <Title level={2}>Enrichment</Title>
              <Text className={styles.description}>
                To find out more details about an observable, enter a domain or
                IP and Enrich it.
              </Text>
              <Form form={form} name="enrich">
                <div>
                  {/* <Tooltip
                  title={
                    'Wildcards are supported at the beginning or end of the domain string but not both at once. (Only allowed in case of PADNS Lookup)'
                  }
                > */}
                  <Form.Item
                    name="threat_name"
                    rules={[
                      {
                        required: true,
                        message: 'Please input the domain name or IP!',
                      },
                    ]}
                  >
                    <Input
                      status={enrichInputState}
                      prefix={
                        enrichInputState === 'error' ? (
                          <ExclamationCircleOutlined />
                        ) : null
                      }
                      ref={searchInput}
                      maxLength={3000}
                      onChange={(e) => onInputChange(e)}
                      placeholder="Enter Domain or IP"
                      style={{
                        border:
                          enrichInputState === 'error'
                            ? '1px solid #ff4d4f'
                            : '1px solid rgba(255, 255, 255, 0.2)',
                        backgroundColor: '#1C3138',
                        color: 'rgba(255, 255, 255, 0.85)',
                      }}
                    />
                  </Form.Item>
                  {/* </Tooltip> */}
                  <Button
                    role={'button10'}
                    size={'large'}
                    onClick={() =>
                      form
                        .validateFields()
                        ?.then(() => {
                          if (
                            form?.getFieldValue('threat_name')?.includes('*')
                          ) {
                            showNotification(
                              simpleErrorNotification({
                                statusCode: 403,
                                message:
                                  'Please enter a valid domain or IP address',
                              }),
                            );
                            setEnrichInputState('error');
                            //this.setState({ exploreInputState: 'error' });
                            return;
                          }

                          if (
                            form?.getFieldValue('threat_name')
                            //&&
                            // !form
                            //   ?.getFieldValue('threat_name')
                            //   ?.includes('*') &&
                            // form?.getFieldValue('threat_name')?.includes('.')
                          ) {
                            // let domainRegex = new RegExp(
                            //   /^(?!https?:\/\/).*(\.[a-zA-Z0-9*-].*)/,
                            // );
                            // if (
                            //   !isIP(form?.getFieldValue('threat_name')) &&
                            //   !form
                            //     ?.getFieldValue('threat_name')
                            //     ?.match(domainRegex)
                            // ) {
                            //   return;
                            // }
                            // if (
                            //   form
                            //     ?.getFieldValue('threat_name')
                            //     ?.includes('[') &&
                            //   !form.getFieldValue('threat_name')?.includes('[.')
                            // ) {
                            //   showNotification(
                            //     simpleErrorNotification({
                            //       statusCode: 403,
                            //       message: 'Special characters not allowed.',
                            //     }),
                            //   );
                            //   setEnrichInputState('error');
                            //   return;
                            // }

                            // if (form?.getFieldValue('threat_name')) {
                            if (
                              !validateEnrichInput(
                                form?.getFieldValue('threat_name'),
                              )
                            ) {
                              showNotification(
                                simpleErrorNotification({
                                  statusCode: 403,
                                  message:
                                    'Please enter a valid domain or IP address.',
                                }),
                              );
                              setEnrichInputState('error');
                            } else {
                              props.resetEnrichment();
                              props.history.push(
                                `/enrichment?name=${form
                                  ?.getFieldValue('threat_name')
                                  ?.replaceAll('[', '')
                                  ?.replaceAll(']', '')
                                  ?.trim()
                                  ?.replaceAll(' ', '')
                                  ?.replaceAll('./', '.')}&type=${
                                  isIP(
                                    form
                                      ?.getFieldValue('threat_name')
                                      ?.replaceAll('[', '')
                                      ?.replaceAll(']', '')
                                      ?.trim()
                                      ?.replaceAll(' ', '')
                                      ?.replaceAll('./', '.'),
                                  )
                                    ? 'ip'
                                    : 'domain'
                                }`,
                              );
                            }
                            // }
                          }
                        })
                        .catch((errorInfo) => {})
                    }
                    type="primary"
                  >
                    Enrich
                  </Button>
                </div>
              </Form>
            </Panel>
          </div>
        </Col>

        <VersionCheck parentComponentStatus={STATUS.LOADED} />
      </Row>
    ) : (
      <PermissionDeniedPage
        message={
          <>
            Enrichment is not part of this subscription plan. To upgrade your
            subscription contact us at{' '}
            <a target="_blank" href="mailto:sales@silentpush.com">
              sales@silentpush.com
            </a>
            .
          </>
        }
      />
    )
  ) : (
    <LoadingSilentPush size={80} positionCenter />
  );
}

export default EnrichmentLanding;
